module.exports = __webpack_public_path__ + "img/compare-track.58eb4032.svg";